import {GET, POST} from "@/services/gateway";
import {trimString} from "@/components/common/utils/trimString";

const listMails = ({pagination, userIds, snapshotDateTime, folderId, searchTerm}) => {
  return POST('exchange/mail/search', {
    pagination,
    userIds,
    snapshotDateTime,
    folderId,
    searchTerm: trimString(searchTerm)
  });
}

const listBreadcrumps = ({userId, folderId, snapshotDate}) => {
  return POST('exchange/mail/breadcrumbs', {userId, folderId, snapshotDate})
}

const exportSnapshot = ({snapshotDateTime, sourceIds, searchTerm, selectedIds, outputFormat, code}) => {
  return POST('exchange/mail/export', {
    snapshotDateTime,
    sourceIds,
    searchTerm: trimString(searchTerm),
    selectedIds,
    outputFormat
  }, {code: code ? code : null})
}

const restoreSnapshot = ({
                           snapshotDateTime,
                           sourceIds,
                           searchTerm,
                           destinationId,
                           snapshotId,
                           selectedIds,
                           RestoreType,
                           code
                         }) => {
  return POST('exchange/mail/restore', {
    snapshotDateTime,
    sourceIds,
    searchTerm: trimString(searchTerm),
    destinationId,
    snapshotId,
    selectedIds,
    RestoreType
  }, {code: code ? code : null})
}

const updateUser = ({userId, includeMailPublicFolders}) => {
  return POST('exchange/mail/update-user', {userId, includeMailPublicFolders})
}

const getEmailDetails = (id) => {
  return GET(`exchange/mail/view?mailId=${id}`,)
}

export {
  listMails,
  listBreadcrumps,
  exportSnapshot,
  restoreSnapshot,
  getEmailDetails,
  updateUser,
}
